// import React, { useState } from "react";
// import { Form, Input, Button, notification } from "antd";
// import axios from "axios";
// import { Link } from "react-router-dom";
// import "./forgetPass.css";
// import { useNavigate} from "react-router-dom";
// import {emailStorage} from "../Store/app/appSlice"
// import { useSelector, useDispatch } from 'react-redux';
// const ForgotPassword = () => {
//   const [currentEmail,setCurrentEmail]=useState();
//   console.log("my curr email is",currentEmail)
//   // const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
//   const dispatch = useDispatch();
//   const email=useSelector(state=>state.appStore.email);
//   const navigate = useNavigate();
//   console.log("email is",email)
//   const handleResetPassword = async(e) =>{
//     e.preventDefault();
//     try{ 
//       dispatch(emailStorage(currentEmail))
//       console.log('email sent',currentEmail)
//       axios.post('/auth/forgot-password', {
//         email:currentEmail
//       })
//       .then(function (response) {
//         console.log(response);
//         navigate("/reset-password");
//       })
//       .catch(function (error) {
//         console.log(error);
//       });
//     }catch(e){
//       console.log('error',e)
//     }
//   }
//   return (

//     <div className="login-container">
//       <div className="logo">
//         Surveyor's <span className="logo-icon">AI</span>
//       </div>
//       <h2 className="login-title">Sign into your account</h2>

//       <div className="card">
//         <form className="login-form">
//           <input
//             type="email"
//             className="input-field"
//             placeholder="Email Address"
//             required
//             onChange={(e)=>setCurrentEmail(e.target.value)}
//           />
//           <button type="submit" className="verify-button" onClick={(e)=>handleResetPassword(e)}>
//             Verify
//           </button>
//         </form>
//       </div>

//       <div className="card signup-card">
//         <p>Dont have an account</p>
//         <button className="signup-button">Sign up</button>
//       </div>
//     </div>
//   );
// }



// export default ForgotPassword;

// import React, { useState } from "react";
// import { Form, Input, Button, notification } from "antd";
// import axios from "axios";
// import { Link } from "react-router-dom";
// import "./forgetPass.css";
// import { useNavigate } from "react-router-dom";
// import { emailStorage } from "../store/user";
// import { useSelector, useDispatch } from 'react-redux';

// const ForgotPassword = () => {
//   const [currentEmail, setCurrentEmail] = useState("");
//   const dispatch = useDispatch();
//   const navigate = useNavigate();
//   const email = useSelector(state => state.user_slice.email);

//   const showNotification = (type, message, description = '') => {
//     notification[type]({
//       message: message,
//       description: description,
//       placement: 'topRight',
//       duration: 3.0, // Changed to 5 seconds
//     });
//   };

//   const handleResetPassword = async (e) => {
//     e.preventDefault();
//     console.log("usestate email",currentEmail)

//     if (!currentEmail) {
//       showNotification('error', 'Validation Error', 'Please enter an email address');
//       return;
//     }

//     try {
//       dispatch(emailStorage(currentEmail));

//       const response = await axios.post('/auth/forgot-password', {
//         email: currentEmail
//       });

//       showNotification('success', 'Success', 'Verification OTP sent');
//       setTimeout(() => {
//         navigate("/reset-password");
//       }, 2000);

//     } catch (error) {
//       if (error.response) {
//         switch (error.response.status) {
//           case 404:
//             showNotification('error', 'Error', 'User does not exist.');
//             break;
//           default:
//             showNotification('error', 'Error', 'An error occurred. Please try again');
//         }
//       } else {
//         showNotification('error', 'Network Error', 'Please check your connection');
//       }
//     }
//   };

//   return (
//     <div className="login-container">
//       <div className="logo">
//         Surveyor's <span className="logo-icon">AI</span>
//       </div>
//       <h2 className="login-title">Sign into your account</h2>

//       <div className="card">
//         <form className="login-form">
//           <input
//             type="email"
//             className="input-field"
//             placeholder="Email Address"
//             required
//             value={currentEmail}
//             onChange={(e) => setCurrentEmail(e.target.value)}
//           />
//           <button 
//             type="submit" 
//             className="verify-button" 
//             onClick={handleResetPassword}
//           >
//             Verify
//           </button>
//         </form>
//       </div>

//       <div className="card signup-card">
//         <p>Don't have an account</p>
//         <button className="signup-button">Sign up</button>
//       </div>
//     </div>
//   );
// };

// export default ForgotPassword;
// new
import React, { useState } from "react";
import { Form, Input, Button, notification } from "antd";
import axios from "axios";
import { Link } from "react-router-dom";
import "./forgetPass.css";
import logo from '../login-module/Logo.png';
import { LazyLoadImage } from "react-lazy-load-image-component";
import { useNavigate } from "react-router-dom";
import { emailStorage } from "../store/user";
import { useSelector, useDispatch } from 'react-redux';

const ForgotPassword = () => {
  const [currentEmail, setCurrentEmail] = useState("");
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const email = useSelector(state => state.user_slice.email);

  const showNotification = (type, message, description = '') => {
    notification[type]({
      message: message,
      description: description,
      placement: 'topRight',
      duration: 3.0,
    });
  };

  const handleResetPassword = async (e) => {
    e.preventDefault();
    console.log("usestate email", currentEmail);

    if (!currentEmail) {
      showNotification('error', 'Validation Error', 'Please enter an email address');
      return;
    }

    // Disable the button immediately when clicked
    setIsButtonDisabled(true);

    try {
      dispatch(emailStorage(currentEmail));

      const response = await axios.post('/auth/forgot-password', {
        email: currentEmail
      });

      showNotification('success', 'Success', 'Verification OTP sent');
      setTimeout(() => {
        navigate("/reset-password");
      }, 2000);

    } catch (error) {
      if (error.response) {
        switch (error.response.status) {
          case 404:
            showNotification('error', 'Error', 'User does not exist.');
            // Re-enable the button only for 404 error
            setIsButtonDisabled(false);
            break;
          case 429:
            showNotification('error', 'Error', 'Wait 1 min before generating another OTP request.');
            // Re-enable the button only for 404 error
            setIsButtonDisabled(false);
            break;
          default:
            showNotification('error', 'Error', 'An error occurred. Please try again');
          // Button remains disabled for other errors
        }
      } else {
        showNotification('error', 'Network Error', 'Please check your connection');
        // Button remains disabled for network errors
      }
    }
  };

  return (
    <div className="login-container">
      <div className="logo">
      <LazyLoadImage
                src={logo}
                alt="Surveyor's AI"
                className="surveyor-icon"
                effect="opacity"
              />
      </div>
      <h2 className="login-title">Sign into your account </h2>

      <div className="card">
        <form className="login-form">
          <input
            type="email"
            className="input-field"
            placeholder="Email Address"
            required
            value={currentEmail}
            onChange={(e) => setCurrentEmail(e.target.value)}
          />
          <button
            type="submit"
            className="verify-button"
            onClick={handleResetPassword}
            disabled={isButtonDisabled} // Add disabled attribute
          >
            {isButtonDisabled ? 'Verifying...' : 'Verify'}
          </button>
          <p className="back-to-login">
                <button 
                    type="button" 
                    className="back-link" 
                    onClick={() => navigate('/login')}
                >
                    Back to Login
                </button>
            </p>
        </form>
      </div>
      {/* signup option */}
      {/* <div className="card signup-card">
        <p>Don't have an account</p>
        <button className="signup-button">Sign up</button>
      </div> */}
    </div>
  );
};

export default ForgotPassword;